<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div class="status-page-container">
	<h1>{{ title }}</h1>
	<mat-table [dataSource]="tests" class="test-results-table">
		<!-- Position Column -->
		<ng-container matColumnDef="position">
			<mat-header-cell *matHeaderCellDef class="position-col">Test No.</mat-header-cell>
			<mat-cell *matCellDef="let element; let i = index" class="position-col">
				{{ i + 1 }}
			</mat-cell>
		</ng-container>

		<!-- Description Column -->
		<ng-container matColumnDef="description">
			<mat-header-cell *matHeaderCellDef class="description-col">Description</mat-header-cell>
			<mat-cell *matCellDef="let element" class="description-col">
				{{ element.description }}
			</mat-cell>
		</ng-container>

		<!-- Duration Column -->
		<ng-container matColumnDef="duration">
			<mat-header-cell *matHeaderCellDef class="duration-col">Duration</mat-header-cell>
			<mat-cell *matCellDef="let element" class="duration-col">
				{{ element.duration | number }} {{ !!element.duration ? 'ms' : '' }}
			</mat-cell>
		</ng-container>

		<!-- Status Column -->
		<ng-container matColumnDef="status">
			<mat-header-cell *matHeaderCellDef class="status-col">Status</mat-header-cell>
			<mat-cell *matCellDef="let element" class="status-col">
				<span
					[ngClass]="element.status"
					*ngIf="element.status === 'success' || element.status === 'failure'; else loading"
					class="material-icons"
				>
					{{ element.status === 'success' ? 'check_circle' : 'cancel' }}
				</span>
			</mat-cell>
		</ng-container>

		<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
		<mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
	</mat-table>
</div>

<ng-template #loading>
	<mat-spinner [diameter]="20"></mat-spinner>
</ng-template>
